<template>
  <!-- Covid19 is a special event - do not display it -->
  <div class="event-details" v-if="event && !event.isCovid19()">
    <FormTextField
      v-if="organizationDetails.enableWhenItHappenedEventQuestion"
      label="When it happened:"
      :value.sync="event.dateOccurred"
      :helpText="$gettext('MM/YYYY')"
      :helpTextTranslate="false"
      @blur="$emit('fieldBlur')"
      required
    />
    <div v-for="question in event.questions" :key="question.id">
      <Question class="question" :question="question" @answer-changed="onAnswerChanged($event)" />
    </div>
  </div>
</template>

<script>
import FormTextField from '@/components/forms/FormTextField'
import Question from '@/components/survey/Question'
import { mapState } from 'vuex'
import utils from '@/services/utils'

export default {
  name: 'EventComponent',
  components: {
    Question,
    FormTextField,
  },
  props: {
    event: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      eventObject: {},
      date: null,
      dateOccurred: null,
    }
  },
  computed: {
    ...mapState(['organizationDetails']),
  },
  methods: {
    onAnswerChanged(question) {
      if (question.answer.text) {
        this.$emit('fieldBlur')
      }
    },
    onDateOccuredChanged() {
      if (this.event.dateOccured) {
        this.$emit('fieldBlur')
      }
    },
    getEventDescription(event) {
      return event?.categoryRef?.descriptionHtml
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/grant-circles';

.event-details-header {
  @extend .card-shape;

  .event-header {
    h4 {
      font-size: 1.5rem;
      font-weight: bold;
      line-height: 2rem;
    }
  }

  .description::v-deep {
    p {
      font-size: 1.25rem;
    }
  }
}
</style>
